import { render, staticRenderFns } from "./newsletter-form-cmp.vue?vue&type=template&id=83c04cb8&scoped=true"
import script from "./newsletter-form-cmp.vue?vue&type=script&lang=js"
export * from "./newsletter-form-cmp.vue?vue&type=script&lang=js"
import style0 from "./newsletter-form-cmp.vue?vue&type=style&index=0&id=83c04cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c04cb8",
  null
  
)

export default component.exports